"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ledgerStore = void 0;
const api_1 = require("client/api");
const store_1 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const util_1 = require("shared/util");
class LedgerStore {
    constructor() {
        this.ledgerData = { value: [] };
        this.key = "0ad8d-f069d-1c660-f4d2c-4ca1c";
        this.showLoader = false;
        /** Query Actions */
        this.orderLedger = async (purchaseOrder) => {
            // console.log(
            //   "purchase order in store-------------------------->",
            //   purchaseOrder
            // );
            const result = await api_1.LedgerEndpoint.orderledger.apiCall(null, {
                purchaseOrder
            });
            if (api_1.isError(result)) {
                return false;
            }
            return result;
        };
        this.loadLedger = async (siteId = store_1.usersStore.user.value.siteId, startDate = util_1.previousMonth(), endDate = util_1.currentDate()) => {
            this.ledgerData.value = [];
            const result = await api_1.LedgerEndpoint.ledgerReport.apiCall(null, {
                siteId: siteId === 0 ? null : siteId,
                startDate,
                endDate
            });
            if (api_1.isError(result)) {
                if (result.code === "NOT_FOUND") {
                    // console.log("not found code in load ledger store");
                    return false;
                }
                this.showLoader = false;
                // alert("Error");
                this.ledgerData = { error: result.code };
                return true;
            }
            this.showLoader = false;
            // this.columnHeaders = this.getColumnHeaders(result.analyticsData);
            this.ledgerData.value = result.analyticsData;
            return true;
        };
        this.replacementOrder = async (purchaseOrder) => {
            await api_1.LedgerEndpoint.replacementOrder.apiCall(null, { purchaseOrder });
        };
        this.adjustLedger = async (siteId, amount, source, currentUserId, ledgerEntryId, notes, refType, reference) => {
            this.ledgerData.value = [];
            const result = await api_1.LedgerEndpoint.adjustledger.apiCall(null, {
                amount,
                currentUserId,
                ledgerEntryId,
                notes,
                refType,
                reference,
                siteId: siteId === 0 ? null : siteId,
                source
            });
            if (api_1.isError(result)) {
                if (result.code === "NOT_FOUND") {
                    // console.log("not found code in load ledger store");
                    return false;
                }
                this.showLoader = false;
                // alert("Error");
                this.ledgerData = { error: result.code };
                return true;
            }
            this.showLoader = false;
            // this.columnHeaders = this.getColumnHeaders(result.analyticsData);
            this.ledgerData.value = result.analyticsData;
            return true;
        };
        this.deleteNullLedgerEntry = async (siteId, ledgerEntryId) => {
            const result = await api_1.LedgerEndpoint.deletenullledger.apiCall(null, {
                siteId,
                ledgerEntryId
            });
            if (api_1.isError(result)) {
                alert("Error in deleting null ledger entries");
            }
        };
        this.getFirstDate = async () => {
            const result = await api_1.LedgerEndpoint.firstDate.apiCall(null, {});
            if (api_1.isError(result)) {
                return false;
            }
            // console.log("result-------->", result);
            return result.date;
        };
        this.shouldHideStartBalanceAdjustment = async (siteId) => {
            const result = await api_1.LedgerEndpoint.shouldHideStartBalanceAdjustment.apiCall(null, { siteId });
            if (api_1.isError(result)) {
                return false;
            }
            // console.log("result-------->", result);
            return result.result;
        };
        /** End Query Actions */
        this.getColumnHeaders = (data) => {
            // Immutably creating a copy of the data so we don't accidentally change the original.
            const analyticsData = [...data];
            const dataObject = mobx_1.toJS(analyticsData[0]);
            const headers = [];
            for (const property in dataObject) {
                if (dataObject.hasOwnProperty(property)) {
                    headers.push(property);
                }
            }
            return headers;
        };
    }
}
__decorate([
    mobx_1.observable
], LedgerStore.prototype, "ledgerData", void 0);
__decorate([
    mobx_1.observable
], LedgerStore.prototype, "columnHeaders", void 0);
__decorate([
    mobx_1.observable
], LedgerStore.prototype, "key", void 0);
__decorate([
    mobx_1.observable
], LedgerStore.prototype, "showLoader", void 0);
__decorate([
    mobx_1.action
], LedgerStore.prototype, "orderLedger", void 0);
__decorate([
    mobx_1.action
], LedgerStore.prototype, "getFirstDate", void 0);
__decorate([
    mobx_1.action
], LedgerStore.prototype, "shouldHideStartBalanceAdjustment", void 0);
__decorate([
    mobx_1.action
], LedgerStore.prototype, "getColumnHeaders", void 0);
exports.ledgerStore = new LedgerStore();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/ledger/store.ts
// module id = 2344
// module chunks = 0